<template>
    <j-page class="role-manage-layout">
        <!--        按钮区域-->
        <div slot="search">
            <el-button type="warning" icon="el-icon-plus" @click="addEvent">新增角色</el-button>
        </div>
        <!--        数据列表-->
        <div slot="table" class="role-manage-table">
            <el-table stripe v-loading="loading" :data="roleList" height="100%">
                <el-table-column prop="roleId" label="ID" align="center" width="50" />
                <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip />
                <el-table-column prop="description" label="描述" align="center" show-overflow-tooltip />
                <el-table-column prop="desensitizationLevel" label="脱敏等级" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{ desensitizationLevelMap[row.desensitizationLevel] }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button @click.stop="editRoleMenu(scope.row)" type="text" class="common-button-add">菜单授权</el-button>
                        <el-button @click.stop="editRole(scope.row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delRole(scope.row)" type="text" class="common-button-del" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!--        新增/编辑弹窗-->
        <el-dialog :title="ctrlTitle[ctrlType]" :visible.sync="showAdd" width="480px" :close-on-click-modal="false">
            <el-form :model="formData" :rules="formRule" ref="AddRuleDom" :inline="false" @keydown.native.enter="checkEvent('AddRuleDom', saveRule)">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="formData.name" placeholder="请输入名称" maxlength="20" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input v-model="formData.description" type="textarea" :rows="3" placeholder="请输入描述" maxlength="200" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="脱敏等级" prop="desensitizationLevel">
                    <el-radio-group v-model="formData.desensitizationLevel">
                        <el-radio v-for="(value, key) in desensitizationLevelMap" :label="Number(key)" :key="key">{{value}}</el-radio>
                    </el-radio-group>
                    <el-popover placement="bottom" width="680" trigger="hover" :visible-arrow="false" :open-delay="400">
                        <i class="el-icon-info el-button--text" slot="reference" style="margin-left: 8px;cursor: pointer;" />
                        <el-table :data="desensitizationTable" border size="small" >
                            <el-table-column property="type" label="类型" />
                            <el-table-column property="type0" :label="desensitizationLevelMap[0]" width="170px" />
                            <el-table-column property="type1" :label="desensitizationLevelMap[1]" width="170px" />
                            <el-table-column property="type2" :label="desensitizationLevelMap[2]" width="170px" />
                        </el-table>
                    </el-popover>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="checkEvent('AddRuleDom', saveRule)" :loading="submitLoad">保存</el-button>
                <el-button type="info" @click="showAdd = false">取消</el-button>
            </span>
        </el-dialog>

        <!--       授权弹窗-->
        <el-dialog title="菜单授权" :visible.sync="showAuth" width="650px" top="10%" :close-on-click-modal="false" @keydown.native.enter="saveAuth">
            <role-menu-tree v-if="showAuth" ref="authTree" :meta="curItem" />
            <span slot="footer">
                <el-button type="primary" @click="saveAuth" :loading="submitLoad">授 权</el-button>
                <el-button type="info" @click="showAuth = false">取消</el-button>
            </span>
        </el-dialog>
    </j-page>
</template>

<script>
    import JPage from "../../../components/JComponents/JPage/JPage";
    import RoleMenuTree from "./RoleMenuTree";
    export default {
        name: "RoleManage",
        components: { JPage, RoleMenuTree },
        data () {
            return {
                desensitizationTable: [
                    { type: '中文姓名', type0: '李思睿', type1: '李**', type2: '***' },
                    { type: '身份证号', type0: '120110199003195762', type1: '*************5762', type2: '*****************' },
                    { type: '手机号码', type0: '13805170034', type1: '138******34', type2: '***********' },
                    { type: '固定电话', type0: '80121234', type1: '****1234', type2: '********' },
                    { type: '地址', type0: '北京市海淀区朝阳路32号', type1: '北京市海淀区****', type2: '***************' },
                    { type: '电子邮箱', type0: 'gzj@163.com', type1: 'g**@163.com', type2: '**********' },
                    { type: '银行卡号', type0: '622260092136854311234', type1: '6222600**********1234', type2: '*********************' },
                    { type: '公司开户银行联号', type0: '1234567890', type1: '12********', type2: '**********' },
                ],
                loading: false,
                submitLoad: false,
                ctrlTitle: {
                  "ADD": "新增角色",
                  "EDIT": "编辑角色"
                },
                desensitizationLevelMap: {
                  0: "不脱敏",
                  1: "部分脱敏",
                  2: "完全脱敏"
                },
                showAuth: false,
                showAdd: false,
                ctrlType: 'ADD',
                formData: {
                    name: '',
                    description: '',
                    desensitizationLevel: 0,
                    menus: [],
                    buttons: []
                },
                formRule: {
                    name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                    description: [{ required: false, message: '请输入描述', trigger: 'change' }],
                    desensitizationLevel: [{ required: true, message: '请选择脱敏等级', trigger: 'change' }]
                },
                curItem: {},
                roleList: [],
                monitorChange: ['EDIT'], // 需要监听编辑改动变化的状态值
            }
        },
        created () {
          this.getRoleList()
        },
        methods: {
            async getRoleList () {
                this.loading = true
                const { data } = await this.$http.get(`/api/roles`).finally(() => { this.loading = false })
                if (data.status !== 'yes') return this.$message.error(data.msg || '获取角色列表异常')
                this.roleList = data.data
            },
            editRoleMenu (row) {
                this.curItem = row
                this.showAuth = true
            },
            async saveAuth () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'put'
                let url = `/api/roles/${this.curItem.roleId}`
                const { data } = await this.$http[method](url, {
                    ...this.curItem,
                    ...this.$refs.authTree.getTreeData()
                }).finally(() => {
                    this.submitLoad = false
                })
                if (data.status !== 'yes') return this.$message.error(data.msg || '角色授权异常')
                this.showAuth = false
                this.$message.success('授权成功')
            },
            addEvent () {
                this.ctrlType = 'ADD'
                this.showAdd = true
            },
            editRole (row) {
                this.ctrlType = 'EDIT'
                this.curItem = { ...row }
                this.formData = this.proxyData({ ...this.formData, ...row, menus: undefined, buttons: undefined })
                this.showAdd = true
            },
            delRole (row) {
                this.$confirm('您确认要删除当前角色吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'delete',
                            url: `/api/roles/${row.roleId}`
                        })
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg || '删除角色异常')
                            this.$message.success('删除成功')
                            this.getRoleList()
                        })
                })
            },
            async saveRule () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/roles`
                if (this.ctrlType === 'EDIT') {
                    url = `/api/roles/${this.curItem.roleId}`
                    method = 'put'
                }
                const { data } = await this.$http[method](url, this.formData).finally(() => {
                    this.submitLoad = false
                })
                if (data.status !== 'yes') return this.$message.error(data.msg || '提交角色异常')
                this.showAdd = false
                this.$message.success('提交成功')
                this.getRoleList()
            },

            // 交互校验相关方法
            checkProxy () {
                if (!this.monitorChange.includes(this.ctrlType)) return true
                let flag = false
                for (let key in this.changeProxy) {
                    if (this.curItem[key] !== this.changeProxy[key]) {
                        flag = true
                        break
                    }
                }
                return flag
            },
            proxyData (obj) {
                this.changeProxy = {}
                const that = this
                if (!obj) return {}
                return new Proxy(obj, {
                    set (target, p, value, receiver) {
                        that.changeProxy[p] = value
                        return Reflect.set(target, p, value, receiver)
                    }
                })
            },
            checkEvent (target, funName) {
                if (!this.checkProxy()) return this.$message.info('数据未变动，无需重复保存')
                this.$refs[target].validate((valid) => {
                    if (valid) {
                        funName()
                    }
                })
            }
        },
        watch: {
            showAdd (nv) {
                if (!nv) {
                    this.$refs['AddRuleDom'] && this.$refs['AddRuleDom'].resetFields()
                    this.formData = { ...this.$options.data().formData }
                }
            }
        }
    }
</script>

<style lang="scss">
    .role-manage-layout {
        .role-manage-table {
            height: 100%;
        }
    }
</style>
